import type { IxcSweepsClearingV1SweepsTaskKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const SWEEPS_TASK_BASE_PATH = getResolvedPath('/clearing/operations/sweep/task');

export const getSweepsTaskPath: EntityPathBuilder<IxcSweepsClearingV1SweepsTaskKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return SWEEPS_TASK_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.sweepsTaskId) {
        return undefined;
      }

      return getResolvedPath(`${SWEEPS_TASK_BASE_PATH}/$taskId`, { taskId: context.keys.sweepsTaskId, ...context.keys });
    }
  }
};

export function getSweepsTaskDetailPath(sweepsTaskId: string | undefined) {
  if (!sweepsTaskId) {
    return undefined;
  }

  return getSweepsTaskPath({ kind: 'detail', keys: { sweepsTaskId } });
}
